import { Fragment } from 'preact';
import Skeleton from '../Skeleton';

const EmiHome = () => {
  return (
    <Fragment>
      <Skeleton
        style={{
          height: '60px',
          marginBottom: '8px',
          borderRadius: '0px 0px 20px 20px',
        }}
      />
      <Skeleton
        style={{
          height: '105px',
          margin: '16px 19px 16px 20px',
          borderRadius: '8px',
        }}
        count={3}
      />
    </Fragment>
  );
};

export default EmiHome;



// WEBPACK FOOTER //
// ./components/salesApp/skeletonScreens/EmiHome.js